import { CommonActionRequestType, RequestType } from '../reducers/requestReducer';
import { RequestActionType } from './requestActions';

export enum ResetPasswordActionType {
    ResetPasswordInit = 'RESET_PASSWORD/INIT',
    ConfirmResetPasswordInit = 'CONFIRM_RESET_PASSWORD/INIT',
    ConfirmResetPasswordSuccess = 'CONFIRM_RESET_PASSWORD_SUCCESS',
}

export interface ResetPassword extends CommonActionRequestType {
    type: ResetPasswordActionType.ResetPasswordInit;
    email: string;
}

export const resetPassword = (email: string): ResetPassword => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.ResetPassword,
    type: ResetPasswordActionType.ResetPasswordInit,
    email,
});

export interface ConfirmResetPassword extends CommonActionRequestType {
    type: ResetPasswordActionType.ConfirmResetPasswordInit;
    payload: { email: string; confirmationCode: string; password: string };
}

export const confirmResetPassword = (payload: {
    email: string;
    confirmationCode: string;
    password: string;
}): ConfirmResetPassword => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.ConfirmResetPassword,
    type: ResetPasswordActionType.ConfirmResetPasswordInit,
    payload,
});

export interface ConfirmResetPasswordSuccess {
    type: ResetPasswordActionType.ConfirmResetPasswordSuccess;
    email: string;
}

export const confirmResetPasswordSuccess = (email: string): ConfirmResetPasswordSuccess => ({
    type: ResetPasswordActionType.ConfirmResetPasswordSuccess,
    email,
});

export type ResetPasswordActions = ConfirmResetPasswordSuccess;
